import apiSlice from './apiSlice';
export interface UserAnalytics {
  totalUsers: number;
  qrUsers: number;
  freeUsers: number;
  premiumUsers: number;
  organicConvertedUsers: number;
  organicConversionRate: string;
  totalPremiumUsers?: number;
  totalPlayCount?: number;
  totalQrScans?: number;
}
export interface CategoryResponse {
  category: isLockedCategory;
  analytics: CategoryAnalytics;
  contentLibrary: ContentLibraryItem[];
}

export interface isLockedCategory {
  id: number;
  title: string;
  description: string;
  isLocked: boolean;
}

export interface CategoryAnalytics {
  totalContent: number;
  totalPlays: number;
  totalPlayCount: number;
  totalUsers: number;
  totalPremiumUsers: number;
  totalFreeUsers: number;
  totalQrScans: number;
}

export interface ContentLibraryItem {
  id: number;
  title: string;
  duration: number;
  playCount: number;
  sourceType: string;
  imageUrl: string;
  createdAt: string;
}

interface LockedAnalyticsResponse {
  analytics: CategoryAnalytics;
}

export const analyticsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getQrAnalytics: builder.query<UserAnalytics, void>({
      query: () => ({
        url: '/analytics/qr-analytics',
        method: 'GET',
      }),
    }),
    getLockedAnalytics: builder.query<CategoryAnalytics, { isLocked: boolean }>({
      query: ({ isLocked }) => ({
        url: '/analytics/locked',
        params: { isLocked },
        method: 'GET',
      }),
      transformResponse: (response: LockedAnalyticsResponse) => response.analytics,
    }),
    getCategoryAnalytics: builder.query<CategoryAnalytics, number>({
      query: (categoryId) => ({
        url: `/analytics/category/${categoryId}`,
        method: 'GET',
      }),
      transformResponse: (response: LockedAnalyticsResponse) => response.analytics,
    }),
  }),
});
export const { useGetQrAnalyticsQuery, useGetCategoryAnalyticsQuery, useGetLockedAnalyticsQuery } =
  analyticsApi;
